import { defineStore } from 'pinia'
import { toRaw } from 'vue'
import Http from '@/services/http'
import CacheService, { getJSONfromCacheResponse } from '@/services/cache'
import {
  VN_COUNTRY_CODE,
  CHINA_COUNTRY_CODE,
  US_COUNTRY_CODE,
  SEVEN_DAYS_IN_MILLISECONDS,
} from '@/utils'
import Logger from '@/services/log';

const PREFIX_CACHE_KEY_IP_RESULT = 'ip_status_result'

const IP_WHITELIST = [
  '5.181.40.233', // team Upload
  '27.72.145.232', // Viettel
  '42.117.26.104' // FPT
]

export const useIpStore = defineStore('ip', {
  state: () => ({
    ip: '',
    isDetecting: false,
    checked: false,
    countryCode: US_COUNTRY_CODE,
    security: {
      vpn: false,
      proxy: false,
      tor: false,
      relay: false,
    },
  }),
  getters: {
    isRegionalBlocked: (state) => {
      const code = state.countryCode?.toUpperCase()
      // Nếu không có mã quốc gia thì mặc định là KHÔNG BLOCK
      if (!code) return false
      return code === VN_COUNTRY_CODE || CHINA_COUNTRY_CODE.includes(code)
    },
    isIpValid(): boolean {
      if (IP_WHITELIST.includes(this.ip)) {
        return true
      }

      const isSecurity =
        !this.security.vpn &&
        !this.security.proxy &&
        !this.security.tor &&
        !this.security.relay

      return isSecurity && !this.isRegionalBlocked
    },
  },
  actions: {
    async detect(ip: string) {
      if (this.checked || this.isDetecting) return
      this.ip = ip
      this.isDetecting = true

      try {
        const apiKey = import.meta.env.VITE_VPNAPI_KEY
        // Get từ cache với key riêng cho từng IP
        const cacheKey = `${PREFIX_CACHE_KEY_IP_RESULT}_${ip}`
        const cached = await CacheService.instance?.get(cacheKey)
        if (cached && cached.value) {
          const result = getJSONfromCacheResponse(cached)
          console.log('result ', result)
          if (result) {
            this.security = result.security
            this.countryCode = result.countryCode || US_COUNTRY_CODE
            this.checked = true
            this.isDetecting = false

            // Logger.log('clientChecked', 0)
            return
          }
        } else if (ip && apiKey) {
          const url = `https://vpnapi.io/api/${ip}?key=${apiKey}`
          const res = await Http.get(url)

          if (res && res.security) {
            const { security, location } = res
            this.security = security
            this.countryCode = location?.country_code || US_COUNTRY_CODE
            this.isDetecting = false
            this.checked = true
            console.log('security ', security)
            console.log('this.countryCode ', this.countryCode)

            // Logger.log('clientChecked', 0)
          }
        } else {
          this.isDetecting = false
          this.checked = true
          // Logger.log('clientChecked', 0)
        }

        console.log('cacheKey ', cacheKey)
        // lưu cache
        CacheService.instance?.set(
          cacheKey,
          {
            ip: ip,
            security: toRaw(this.security),
            countryCode: this.countryCode,
          },
          SEVEN_DAYS_IN_MILLISECONDS
        )
      } catch (error) {
        console.error('IP Store detection error:', error)
        // [Logic Fallback]: Nếu lỗi, gán về dữ liệu để isIpValid tự nhảy về TRUE
        this.security = { vpn: false, proxy: false, tor: false, relay: false }
        this.countryCode = US_COUNTRY_CODE
        this.isDetecting = false
        this.checked = true
        // Logger.log('clientChecked', 0)
      } finally {

      }
    },
  },
})